import {
  AbortCaseServiceInput,
  AbortCaseServiceOutput,
  ClerkService,
  FailCaseServiceInput,
  FailCaseServiceOutput,
} from '@core/model/service/clerkService';
import { injectable } from 'inversify';

@injectable()
export class IMClerkService implements ClerkService {
  async abortCase(_input: AbortCaseServiceInput): AbortCaseServiceOutput {
    return;
  }

  async failCase(_input: FailCaseServiceInput): FailCaseServiceOutput {
    return;
  }
}
